import React, { useEffect, useRef, useState } from "react";
import TableHeader from "./components/TableHeader";
import ListTable from "../../../components/Table";
import { useSelector } from "react-redux";
import moment from "moment";
import Action from "../../../components/Action";
import ShowModal from "../../../components/Modal/ShowModal";
import ViewApprovalAuction from "./components/ViewApprovalAuction.js";
import Widget from "../../../components/Widget/index.js";
import ChangeStatus from "./components/ChangeStatus.js";
import ViewNotes from "../../../components/ViewNotes.js";
import { dateFormate, formatAsNOK, renderStatus } from "../../../utils/commonFunction.js";
import DetailUserModel from "../../Auctions/DetailUserModel.js";
import BidsDetailModel from "../../Auctions/BidsDetailModel.js";

const Index = () => {
  const [open, setOpen] = useState(false);
  const targetRef = useRef();
  const { language } = useSelector((state) => state.Language);
  const renderActions = (record) => {
    // record.ModelYear = moment(record.ModelYear).format('YYYY-DD-MM');
    return (
      <div className="flex flex-col">
        <ShowModal modalName="Change_Status_Modal" record={record} buttonName={language["Change_Status"]} />
        <ShowModal modalName="View_Common_Notes" record={record} buttonName={language["auction_view_note"]} />
      </div>
    );
  };

  const renderPrice = (price) => {
    let convertPrice = formatAsNOK(price);
    let amount = `${convertPrice} ${process.env.REACT_APP_CURRENCY} `;
    return amount;
  };

  const columns = [
    {
      title: language["user_id"],
      render: (record) => <span>{record.auctionId}</span>,
      key: "Id",
    },
    {
      title: language["auctions_closed_title"],
      render: (record) => <span className="capitalize">{record?.formStructure?.title}</span>,
      key: "Title",
    },
    {
      title: language["Opening_Price"],
      render: (record) => <span>{renderPrice(record?.formStructure?.price)}</span>,
      key: "Price",
      width: 250,
    },
    {
      title: language["Won_Price"],
      render: (record) => <span>{record && renderPrice(record?.wonBidPrice)}</span>,
      key: "wonPrice",
      width: 250,
    },
    {
      title: language["auctions_closed_createdBy"],
      render: (record) => (
        <div>
          <ShowModal
            modalName="User_Detail_Model"
            record={record}
            className="font-roboto-bold text-14 capitalize hover:underline text-blue-500"
            buttonName={`${record?.firstName} ${record?.lastName}`}
          />
          <p className="font-roboto-regular my-0 text-14">{record?.email}</p>
          <p className="font-roboto-regular my-0 text-14">{record?.phoneNumber}</p>
        </div>
      ),
      key: "Created By",
    },
    {
      title: language["auctions_live_noOfBids"],
      render: (record) => (
        <>
          {record?.totalBider > 0 ? (
            <ShowModal
              modalName="Bids_Detail_Model"
              record={record}
              className="hover:underline text-blue-500 cursor-pointer"
              buttonName={record?.totalBider}
            />
          ) : (
            "----"
          )}
        </>
      ),
      key: "bids",
    },
    {
      title: language["auctions_closed_won_bider"],
      render: (record) =>
        record && record?.wonBidder ? (
          <div>
            <ShowModal
              modalName="User_Detail_Model"
              record={{ createdBy: record?.wonBidder?._id }}
              className="font-roboto-bold capitalize hover:underline text-blue-500"
              buttonName={`${record?.wonBidder?.firstName} ${record?.wonBidder?.lastName}`}
            />
            <p className="font-roboto-regular my-0 text-14">{record?.wonBidder?.email}</p>
            <p className="font-roboto-regular my-0 text-14">{record?.wonBidder?.phoneNumber}</p>
          </div>
        ) : (
          ""
        ),
      key: "wonBider",
    },
    {
      title: language["auctions_closed_createdAt"],
      render: (record) => <span>{dateFormate(record.createdAt)}</span>,
      key: "Created At",
    },
    {
      title: language["Closed_At"],
      render: (record) => <span>{dateFormate(record.expiredAt)}</span>,
      key: "closedAt",
    },
    {
      title: language["Status"],
      render: (record) => <span>{renderStatus(record.status)}</span>,
      key: "status",
    },
    {
      title: "",
      render: (record) => <Action>{renderActions(record)}</Action>,
      key: "actions",
      width: "50px",
      fixed: "right"
    },
  ];
  const allColumnKeys = [
    "Id",
    "Title",
    "Price",
    "wonPrice",
    "Duration",
    "bids",
    "wonBider",
    "Created By",
    "Created At",
    "closedAt",
    "status",
    "actions",
  ];
  const [selectedColumnKeys, setSelectedColumnKeys] = useState(allColumnKeys);
  const [checkedList, setCheckedList] = useState(allColumnKeys);
  const [tableColumns, setTableColumns] = useState(columns);
  function isChecked(value) {
    return checkedList.includes(value);
  }
  function handleSelection(key) {
    const tempList = [...checkedList];
    if (tempList.includes(key)) {
      const index = tempList.indexOf(key);
      tempList.splice(index, 1);
    } else {
      tempList.push(key);
    }
    setCheckedList(tempList);
  }
  function handleConfirmation() {
    setSelectedColumnKeys(checkedList);
  }
  useEffect(() => {
    if (selectedColumnKeys) {
      if (selectedColumnKeys.length) {
        const temp = columns.filter((f) => selectedColumnKeys.includes(f.key));
        setTableColumns(temp);
      } else {
        setTableColumns(columns);
      }
    }
    return () => { };
  }, [selectedColumnKeys]);
  const checkBoxData = columns.map((m) => ({ key: m.key, title: m.title }));
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  return (
    <Widget>
      <TableHeader
        targetRef={targetRef}
        handleOpenChange={handleOpenChange}
        hide={hide}
        checkBoxData={checkBoxData}
        open={open}
        isChecked={isChecked}
        handleSelection={handleSelection}
        handleConfirmation={handleConfirmation}
      />
      <div ref={targetRef}>
        <ListTable
          customQuery={{ status: "inProcess" }}
          apiName="getClosedAuctions"
          recordName="progressAuction"
          columns={tableColumns}
        />
      </div>
      <ViewApprovalAuction />
      <DetailUserModel />
      <BidsDetailModel />
      <ChangeStatus />
      <ViewNotes />
    </Widget>
  );
};

export default Index;
